// Where the fixture page lives when something mounts it (tests, the screenshot
// harness). No route in the app serves it.
export const FIXTURE_PATH = '/tour-fixture';
export const FIXTURE_DETAILS_PATH = `${FIXTURE_PATH}/details`;
